/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "./BaseCom";
import { qreq } from "../shared/qrequest";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import FormLabel from "./FormLabel";
import Card from "./Card";
import Icon from "./Icon";
import Auth from "../shared/Auth";
import AppActions from "./AppActions";
import { Link } from "react-router-dom";
import L from "./Lang";
import { SidebarGlobal } from "./_Sidebar";

class UserView extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
        await this.load();
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    load = async () => {
        try {
            const j = await qreq.getAsync('/api/user/info/' + this.props.params.id);
            if (j.item) {
                this.setState({ item: j.item });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    render() {
        SidebarGlobal.setSubNav(<>
            <Link to={'/user/edit/' + this.state.item?.id} className="btn btn-primary">
                <Icon icon="faPencil" /> <span className="d-none d-md-inline"><L>Edit User</L></span>
            </Link>
        </>);
        return <div className="container-fluid">
            <h1>Profile</h1>
            {Auth.hasPolicy('admin') && <AppActions>
                <Link to={'/user/edit/' + this.state.item?.id} className="btn btn-primary btn-lg">
                    <Icon icon="faPencil" /> <L>Edit User</L>
                </Link>
            </AppActions>}
            <Card title={<><Icon icon="faUser" /> {this.state.item?.fullName}</>}>
                <FormLabel model={this.state.item?.roleGroupName} label="Role" />
            </Card>
        </div>;
    }
}

export default withParamsAndNavigate(UserView);